import servicesClient from 'src/services/servicesClient'

import { OrderForm } from '../../entity/orderForm'
import type { CustomDataBody } from '../types/customData'

export const addCartCustomData = async (
  orderFormId: string,
  body: CustomDataBody
) => {
  // TODO: make this work at development environment
  // For now, the CORS configuration only allows homolog and production environments
  if (process.env.NODE_ENV === 'development') {
    return
  }

  try {
    if (process.env.NODE_ENV === 'development') {
      return
    }

    const { data } = await servicesClient.put(
      `/v1/checkout/pub/orderForm/${orderFormId}/customData/${body.appId}`,
      body.customData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return new OrderForm(data)
  } catch (error) {
    throw new Error('addCartCustomData:', error)
  }
}
